/**
 * Header functionality
 * - Handles sticky header behavior
 * - Changes header background on scroll
 * - Handles mobile menu toggling
 */

export function initHeader() {
  const header = document.querySelector('header');
  const mobileMenuBtn = document.querySelector('#mobileMenuBtn');
  const mobileMenu = document.querySelector('#mobileMenu');
  
  if (!header) return;
  
  // Handle sticky header and background change on scroll
  const updateHeader = () => {
    if (window.scrollY > 50) {
      header.classList.add('bg-white', 'shadow-md');
      header.classList.remove('bg-transparent');
      // Update text colors for white background
      header.querySelectorAll('nav a').forEach(link => {
        link.classList.remove('text-white');
        link.classList.add('text-primary');
      });
      mobileMenuBtn?.classList.remove('text-white');
      mobileMenuBtn?.classList.add('text-primary');
    } else {
      header.classList.remove('bg-white', 'shadow-md');
      header.classList.add('bg-transparent');
      // Update text colors for transparent background
      header.querySelectorAll('nav a').forEach(link => {
        link.classList.add('text-white');
        link.classList.remove('text-primary');
      });
      mobileMenuBtn?.classList.add('text-white');
      mobileMenuBtn?.classList.remove('text-primary');
    }
  };

  // Initial header state based on current page
  const isHomePage = window.location.pathname === '/' || window.location.pathname.includes('index.html');
  if (!isHomePage) {
    header.classList.add('bg-white', 'shadow-md');
    header.classList.remove('bg-transparent');
    header.querySelectorAll('nav a').forEach(link => {
      link.classList.remove('text-white');
      link.classList.add('text-primary');
    });
    mobileMenuBtn?.classList.remove('text-white');
    mobileMenuBtn?.classList.add('text-primary');
  }
  
  window.addEventListener('scroll', updateHeader);
  
  // Handle mobile menu toggle
  if (mobileMenuBtn && mobileMenu) {
    mobileMenuBtn.addEventListener('click', () => {
      mobileMenu.classList.toggle('hidden');
      const menuIcon = mobileMenuBtn.querySelector('.menu-icon');
      const closeIcon = mobileMenuBtn.querySelector('.close-icon');
      
      if (menuIcon && closeIcon) {
        menuIcon.classList.toggle('hidden');
        closeIcon.classList.toggle('hidden');
      }
    });
    
    // Close mobile menu when clicking outside
    document.addEventListener('click', (e) => {
      if (!mobileMenuBtn.contains(e.target) && !mobileMenu.contains(e.target)) {
        mobileMenu.classList.add('hidden');
        
        const menuIcon = mobileMenuBtn.querySelector('.menu-icon');
        const closeIcon = mobileMenuBtn.querySelector('.close-icon');
        
        if (menuIcon && closeIcon) {
          menuIcon.classList.remove('hidden');
          closeIcon.classList.add('hidden');
        }
      }
    });
  }
}